import { render, staticRenderFns } from "./UserLeads.vue?vue&type=template&id=46ad9802&"
import script from "./UserLeads.vue?vue&type=script&lang=js&"
export * from "./UserLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports